import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Tag } from '../../Elements/Tag/index.js';
import { Tooltip } from '../../Feedback/Tooltip/index.js';
import { Wrapper, List, ListItem } from './styled.js';
export const ListWithCounter = React.memo(function ListWithCounter({ list, defaultVisibleItems = 1 }) {
    if (!list) {
        return null;
    }
    const visibleItems = list.slice(0, defaultVisibleItems);
    const hiddenItems = list.slice(defaultVisibleItems);
    return (_jsxs(Wrapper, { "data-testid": 'content-wrapper', children: [visibleItems.map((item, index) => (_jsx("span", { children: item + (index < visibleItems.length - 1 ? ', ' : '') }, `${item}-${index}`))), hiddenItems.length > 0 && (_jsx(Tooltip, { type: 'popper', contentPadding: false, delayHide: 150, trigger: ['hover', 'click'], dataTestId: 'list-counter-tooltip', tooltip: _jsx(List, { children: hiddenItems.map((item) => (_jsx(ListItem, { "data-testid": 'list-counter-item', children: item }, item.replace(/\s/g, '')))) }), children: _jsx(Tag, { dataTestId: 'list-counter-tag', title: ` +${hiddenItems.length}` }) }))] }));
});
